module.exports = new __parcel__URL__("zendesk--dark.3e133819.svg").toString();